import type { FirebaseOptions } from 'firebase/app';

// Configuració sense el SDK (només un tipus): la part pública la fa servir per llegir les vistes
// i les fotos amb peticions directes, sense carregar Firebase (§10.4).

const env = import.meta.env;
export const usingEmulators = (env.VITE_USE_EMULATORS ?? (env.DEV ? 'true' : 'false')) === 'true';

/** Una variable buida al .env compta com a absent. */
const opt = (v: string | undefined) => (v === undefined || v === '' ? undefined : v);

export const options: FirebaseOptions = {
  // Amb l'emulador n'hi ha prou amb un projectId; la clau no es comprova.
  apiKey: opt(env.VITE_FIREBASE_API_KEY) ?? 'demo-key',
  // Amb l'emulador, sempre un projecte demo-*: així cap escriptura no pot arribar a producció (§3, D14).
  projectId: usingEmulators ? 'demo-blauturquesa' : (opt(env.VITE_FIREBASE_PROJECT_ID) ?? 'blauturquesa-immo'),
};
const authDomain = opt(env.VITE_FIREBASE_AUTH_DOMAIN);
const storageBucket = opt(env.VITE_FIREBASE_STORAGE_BUCKET);
const appId = opt(env.VITE_FIREBASE_APP_ID);
// Necessari per a les notificacions (FCM, §9): sense ell, getToken falla amb «missing messagingSenderId».
const messagingSenderId = opt(env.VITE_FIREBASE_MESSAGING_SENDER_ID);
if (authDomain) options.authDomain = authDomain;
// Amb l'emulador, el bucket per defecte del projecte demo (el mateix que fa servir l'Admin SDK de les Functions).
if (usingEmulators) options.storageBucket = 'demo-blauturquesa.appspot.com';
else if (storageBucket) options.storageBucket = storageBucket;
if (appId) options.appId = appId;
if (messagingSenderId) options.messagingSenderId = messagingSenderId;
